<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <b-button variant="danger" class="text-white" :disabled="calculating" v-on:click="showredcasesModal()"><i v-show="!calculating" class="fa fa-calculator"></i><i v-show="calculating" class="fa fa-spinner fa-spin"></i> Calcular casos</b-button>
    </div>
    <Grid name="redcasesGrid" ref="redcasesGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
  <b-modal ref="redcasesModal" id="redcasesModal">
    <p v-if="!calculating">Vai re-calcular os casos.</p>
    <b-form-input type="number" v-model="calculateYear" />
    <p v-if="calculating">A re-calcular os casos.</p>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-left" variant="secondary" @click="hideModal">
        Cancelar
      </b-btn>
      <b-btn size="sm" class="float-right" variant="primary" @click="calculate">
        Continuar
      </b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'

export default {
  name: 'ActivitiesGrid',
  components: {
    Grid
  },
  data() {
    return {
      calculating: false,
      calculateYear: null,
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'id': {
          type: 'number',
          editable: false
        }
      },
      url: 'redcases',
      preload: [],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '80px',
        editable: false
      },
      {
        field: 'familymember.data.name',
        title: 'Nome',
        width: '180px'
      },
      {
        field: 'familymember.data.compound_key',
        title: 'Chave',
        width: '180px'
      },
      {
        field: 'tried',
        title: 'Inscreveu-se',
        width: '180px'
      },
      {
        field: 'accepted',
        title: 'Aceite',
        width: '180px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      if (this.$auth.check('familymembers.edit')) {
        var route = router.resolve({
          name: 'familymembers.edit',
          params: {
            id: item.family_member_id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> ficha</a>'
      } else if (this.$auth.check('familymembers.view')) {
        var route = router.resolve({
          name: 'familymembers.view',
          params: {
            id: item.family_member_id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> ficha</a>'
      }
      return ''
    },
    hideredcasesModal: function() {
      this.$refs.redcasesModal.hide()
    },
    showredcasesModal: function() {
      this.$refs.redcasesModal.show()
    },
    calculate: function() {
      this.calculating = true

      this.axios.post('redcases/calculate', { year: this.calculateYear })
        .then(response => {
          this.$bvToast.toast('Casos calculados', { autoHideDelay: 5000, variant: 'success', solid: true})
          this.hideredcasesModal();
          this.calculating = false
          this.$refs.redcasesGrid.reload();
        }).catch(error => {
          this.hideredcasesModal();
          this.$bvToast.toast('Houve um erro a calcular', { autoHideDelay: 5000, variant: 'danger', solid: true})
          this.calculating = false
        })
    },
  },
  created() {
    d = new Date();
    this.calculateYear = d.getFullYear()
  }
}
</script>
